/**
 * @file     legal.ts
 * @readme   ../../CLAUDE.md
 * @purpose  English strings for legal pages that have no inline defaultValue.
 *           All other Privacy Policy and Terms of Service copy lives as
 *           defaultValue strings in src/views/privacy and src/views/terms;
 *           keys duplicated here would silently override those views, so this
 *           file must stay limited to keys the views render without defaults.
 */

export const legal = {
  privacy: {
    smsTerm1:
      '1. Ray Rasouli, Real Broker B.C. Ltd., uses SMS to confirm appointments, send reminders, and notify clients of schedule updates or important changes.',
    smsTerm2:
      '2. You can cancel the SMS service at any time. Just text "STOP". After you send the SMS message "STOP" to Ray, Ray will send you an SMS message to confirm that you have been unsubscribed. After this, you will no longer receive SMS messages from Ray. If you want to join again, tick the text-message box on a form, and Ray will start sending SMS messages to you again.',
    smsTerm3:
      '3. If you are experiencing issues with the messaging program, you can reply with the keyword "HELP" for more assistance, or you can get help directly at ray@relta.ca.',
    smsTerm4:
      '4. Carriers are not liable for delayed or undelivered messages.',
    smsTerm5:
      '5. As always, message and data rates may apply for any messages sent to you from Ray and to Ray from you. Message frequency may vary. If you have any questions about your text plan or data plan, it is best to contact your wireless provider.',
    smsTerm6:
      '6. If you have any questions regarding privacy, please read this Privacy Policy in full.',
  },
} as const;
